import { render, staticRenderFns } from "./navAdd.vue?vue&type=template&id=525fb9c0&scoped=true"
import script from "./navAdd.vue?vue&type=script&lang=js"
export * from "./navAdd.vue?vue&type=script&lang=js"
import style0 from "./navAdd.vue?vue&type=style&index=0&id=525fb9c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525fb9c0",
  null
  
)

export default component.exports